export interface QuotationVehicle {
    insuranceId: number,
    licensePlate: string,
    vehicleName: string,
    brandId: number,
    year: number,
    chassi: string
}

export function quotationVehicleFactory(insuranceId: number, licensePlate: string, vehicleName: string, brandId: number, year: number, chassi: string) {
    return {
        insuranceId: insuranceId,
        licensePlate: licensePlate,
        vehicleName: vehicleName,
        brandId: brandId,
        year: year,
        chassi: chassi,
    } as QuotationVehicle;
}
